import React from 'react';

// Shared layout for the policy pages (Refund, Terms, Shipping, Privacy) —
// same numbered-section structure as the original site, restyled to match
// the rest of the app instead of the old Astra/Elementor theme.
const LegalPage = ({ title, effectiveDate, intro, sections }) => (
  <main className="container-lux py-16 md:py-24 max-w-3xl">
    <p className="tracking-luxe text-[#b78d3c] mb-3">Policy</p>
    <h1 className="font-display text-5xl md:text-6xl mb-2">{title}</h1>
    {effectiveDate && (
      <p className="text-[#1a120b]/50 text-sm mb-10">
        Effective {effectiveDate}
      </p>
    )}
    {intro && (
      <p className="text-[#1a120b]/75 leading-relaxed mb-12">{intro}</p>
    )}
    <div className="space-y-10">
      {sections.map((s, i) => (
        <section key={i}>
          <h2 className="font-display text-2xl mb-3">{s.heading}</h2>
          {s.paragraphs?.map((p, j) => (
            <p key={j} className="text-[#1a120b]/75 leading-relaxed mb-3">
              {p}
            </p>
          ))}
          {s.list && (
            <ul className="list-disc pl-5 space-y-2 text-[#1a120b]/75 leading-relaxed">
              {s.list.map((item, k) => (
                <li key={k}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  </main>
);

export default LegalPage;
